module.exports = __webpack_public_path__ + "img/06_Schnupperangebot-4-Module.4c6ef736.svg";